import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'trending-up', 'TrendingUp', [["path",{"d":"M3 17l6 -6l4 4l8 -8"}],["path",{"d":"M14 7l7 0l0 7"}]]);